export const menuTranslations = {
  en: {
    header: 'Portolano del Po',
    subheader: 'For all Po river sailors',
  },
  it: {
    header: 'Portolano del Po',
    subheader: 'Per tutti i naviganti del fiume Po',
  }
}; 